import { SIDEBAR_RAIL } from "./sidebarRail.config";
import { ROUTES } from "../routes/routes.constants";
import { transformModulesToMenu } from "../utils/menuTransformer";
import { getModuleLabel } from "./moduleResolver";
/**
 * Returns the UI label for the active route.
 * Keeps header/title logic centralized and DRY.
 *
 * @param pathname - Current route pathname
 * @param modules - Modules from Redux store (optional, for dynamic menu)
 * @returns Page label
 */
export function getActivePageLabel(pathname, modules = []) {
    // Create Report Edit / View: the header names the page, not the module.
    if (pathname.startsWith(ROUTES.createReportEdit.path.replace("/:reportId", "/")))
        return "Edit Report";
    if (pathname.startsWith(ROUTES.createReportView.path.replace("/:reportId", "/")))
        return "View Report";
    // 0. Multi-page modules: show the OWNING module's name (DB label first, then
    // the static descriptor name for modules absent from the DB, e.g. Roles &
    // Permissions). Only mapped module routes / their sub-pages are handled here;
    // everything else falls through to the normal per-page logic below.
    const moduleLabel = getModuleLabel(pathname, modules);
    if (moduleLabel)
        return moduleLabel;
    // 1. Explicit hardcoded overrides (for routes that need special labels)
    if (pathname === ROUTES.profile.path)
        return "Profile";
    if (pathname === ROUTES.metaAdAudit.path)
        return "Meta Ad Audits";
    if (pathname.startsWith('/meta-ad-audit/report/'))
        return "Meta Ad Audit Report";
    if (pathname === ROUTES.accountSummary.path)
        return "Account Summary";
    if (pathname === ROUTES.clients.path)
        return "Clients";
    if (pathname === ROUTES.affiliateAccountPerformance.path)
        return "Affiliate Account Performance";
    if (pathname.startsWith('/outreach-tracker/'))
        return "Outreach Tracker";
    // 2. Check sidebar rail (Home, Favorites, Settings, etc.)
    for (const item of SIDEBAR_RAIL) {
        if (item.to && item.to === pathname)
            return item.label;
    }
    // 3. Check dynamic menu from modules (Management, etc.)
    const findLabelInMenu = (items) => {
        for (const item of items) {
            if (item.to === pathname)
                return item.label;
            if (item.items && item.items.length > 0) {
                const found = findLabelInMenu(item.items);
                if (found)
                    return found;
            }
        }
        return null;
    };
    if (modules && modules.length > 0) {
        const dynamicMenu = transformModulesToMenu(modules);
        for (const group of dynamicMenu) {
            const found = findLabelInMenu(group.items || []);
            if (found)
                return found;
            if (group.to === pathname)
                return group.label;
        }
    }
    // 4. Generic lookup in ROUTES constants (fallback)
    // Convert camelCase name to Start Case (e.g. userList -> User List)
    for (const route of Object.values(ROUTES)) {
        if (route.path === pathname) {
            return route.name
                .replace(/([A-Z])/g, ' $1') // insert space before capital letters
                .replace(/^./, (str) => str.toUpperCase()) // capitalize first letter
                .trim();
        }
    }
    // Final Fallback
    return "Account Overview";
}
